export enum MimeType {
  IMAGE_JPG = "image/jpg",
  IMAGE_JPEG = "image/jpeg",
  IMAGE_PNG = "image/png",
  IMAGE_GIF = "image/gif",
  DOC = "application/msword",
  DOCX = "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
  PDF = "application/pdf",
  MSG_OUTLOOK = "application/vnd.ms-outlook",
}

export const mimeToExtensionMap: Record<MimeType, string> = {
  [MimeType.IMAGE_JPG]: ".jpg",
  [MimeType.IMAGE_JPEG]: ".jpeg",
  [MimeType.IMAGE_PNG]: ".png",
  [MimeType.IMAGE_GIF]: ".gif",
  [MimeType.DOC]: ".doc",
  [MimeType.DOCX]: ".docx",
  [MimeType.PDF]: ".pdf",
  [MimeType.MSG_OUTLOOK]: ".msg",
}

export const BYTES_PER_MB = 1024 * 1024
export const MAX_UPLOAD_FILES = 15
export const MAX_UPLOAD_SIZE_BYTES = 10 * 1024 * 1024
export const MAX_FILE_NAME_LENGTH = 255
export const FILE_NAME_DISPLAY_MAX_LENGTH = 100
export const ATTACHMENT_DESCRIPTION_MAX_LENGTH = 64 // matches backend MAX_LABEL_LENGTH
export const UPLOAD_CONCURRENCY_LIMIT = 3
export const UPLOAD_FAILURE_TOAST_AUTO_HIDE_DURATION_MS = 8000

export const IMAGE_MIME_TYPES = [MimeType.IMAGE_JPG, MimeType.IMAGE_JPEG, MimeType.IMAGE_PNG, MimeType.IMAGE_GIF]
export const IMAGE_MIME_TYPES_WITH_PDF = [...IMAGE_MIME_TYPES, MimeType.PDF]
export const DOCUMENT_UPLOAD_MIME_TYPES = [
  ...IMAGE_MIME_TYPES,
  MimeType.DOC,
  MimeType.DOCX,
  MimeType.PDF,
  MimeType.MSG_OUTLOOK,
]

export const FILE_UPLOAD_TAKES_TIME_MESSAGE =
  "File uploads may take some time to process. If any files do not appear, please refresh the screen."

export const DOCUMENT_UPLOAD_TYPES_LABEL = "PDF, PNG, JPG, DOC or MSG"

/**
 * File extensions that should be opened in a new tab instead of downloaded
 */
export const OPENABLE_EXTENSIONS = new Set(["pdf", "png", "jpg", "jpeg", "gif", "txt", "html"])
